import SelectPackageData from '@/components/sponsorship/SelectPackageData'

function SelectPackage() {
  return <SelectPackageData />
}

export default SelectPackage
